import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Spinner from '../common/Spinner';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
  requireGuide?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false, requireGuide = false }) => {
  const { isAuthenticated, currentUser, loading } = useAuth();

  if (loading) {
    return <Spinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && currentUser?.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  if (requireGuide && currentUser?.role !== 'GUIDE') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
